import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'PopularTitle',
};

interface Props {
  title?: string;
  content?: {};
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: { default: '' },
    content: { default: () => ({}) }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})